<template>
  <div>
    <v-card>
      <v-img max-height="85" src="@/assets/img/background.png">
        <v-app-bar flat class="mt-2" color="rgba(0, 0, 0, 0)">
          <v-btn color="white" @click="goBack()" icon>
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <p class="text-white-title mt-4">
            Detail Role: {{ res_accesslist.meta.parent.name }}
          </p>
        </v-app-bar>
      </v-img>
    </v-card>
    <div v-if="showPages">
      <v-skeleton-loader
        class="ma-5"
        type="article, actions"
      ></v-skeleton-loader>
    </div>
    <v-card class="mx-3 mt-5 px-2 w-100" v-else>
      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <v-form @submit.prevent="handleSubmit(submitForm)">
          <v-row>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pb-0">
              <p class=" text-bold-sm mt-1 border-bottom pb-1">
                Select Menus:
              </p>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
              <v-data-table
                :headers="headers"
                :items="res_menu"
                v-model="selected"
                disable-sort
                hide-default-footer
                item-key="id"
                show-select
                loading-text="Loading... Please wait"
              >
              </v-data-table>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-0">
              <v-alert border="left" type="warning" elevation="1">
                Please be careful in making roles, please do not make roles
                arbitrarily
              </v-alert>
            </v-col>
            <v-col cols="12" lg="12" md="12" sm="12" xs="12" class="pt-2">
              <v-btn
                type="submit"
                color="#913151"
                class="text-center ma-1"
                width="100%"
                dark
                :loading="loading"
                small
              >
                <span class="text-capitalize">Update</span>
              </v-btn>
              <v-btn
                color="#ef4036"
                @click.prevent="closeSuccessNavigate"
                class="text-center ma-1"
                width="100%"
                dark
                text
                small
              >
                <span class="text-capitalize">Cancel</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </ValidationObserver>
    </v-card>
    <!-- dialog success -->
    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="green" size="100px">mdi-checkbox-marked-circle</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Insert Role<br />Success</v-card-title
        >
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="closeSuccessNavigate"
            color="green"
            :loading="loading"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- dialog failed -->
    <v-dialog v-model="dialog2" persistent max-width="350">
      <v-card class="pa-8 pb-10 d-flex flex-column justify-center">
        <v-icon color="#F32626" size="100px">mdi-alert-circle-outline</v-icon>
        <v-card-title class="title-card mx-auto text-center"
          >Insert Role<br />Failed</v-card-title
        >
        <p class="mx-auto">The Code already exists</p>
        <v-card-actions class="pa-0">
          <v-spacer></v-spacer>
          <v-btn
            @click.prevent="dialog2 = false"
            color="green"
            class="mt-3 w-full"
            width="100%"
            dark
          >
            <span class="text-capitalize">Okay</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const system = createNamespacedHelpers("system");
export default {
  data() {
    return {
      tab: null,
      dates: [],
      dialog2: false,
      dialog: false,
      errorMessage: null,
      loading: false,
      selected: [],
      roleName: null,
      e1: 1,
      formInput: [],
      listuser: [],
      menu_id: [],
      itemDeleted: [],
      itemCreate: [],
      headers: [{ text: "Menu Name", value: "name" }]
    };
  },
  watch: {
    res_accesslist(val) {
      this.selected = val.data;
    }
  },
  computed: {
    ...system.mapState(["res_menu", "res_accesslist"]),
    showPages() {
      return this.res_accesslist.length > 0 && this.res_menu.length > 0;
    }
  },
  components: {},
  mounted() {
    this.$store.commit("system/SET_IDROLE", this.$route.params.id);
    this.$store.dispatch("system/getAccessListu");
    this.$store.dispatch("system/getMenu");
  },
  methods: {
    onTagValueChange(e) {
      this.employeeName = e.employee_name;
      this.posisition = e.posisition;
    },
    closeSuccessNavigate() {
      this.dialog = false;
      setTimeout(() => {
        this.$router.push("/role");
      }, 200);
    },
    goBack() {
      this.$router.push("/role");
    },
    submitForm() {
      this.$store.commit("system/SET_IDROLE", this.$route.params.id);
      // this.loading = true;
      this.listuser = this.res_accesslist.data;
      this.listuser.forEach(item => {
        if (!this.selected.includes(item)) {
          this.itemDeleted.push({
            access_id: item.id
          });
        }
      });
      if (this.itemDeleted.length > 0) {
        this.$store.commit("system/SET_ACCESSDELETE", this.itemDeleted);
        this.$store.dispatch("system/deleteAccess");
      }
      this.selected.forEach(data => {
        this.formInput.push({
          access_id: data.id
        });
      });
      this.$store.commit("system/SET_ACCESSCRETE", this.formInput);
      this.$store
        .dispatch("system/createAccess")
        .then(response => {
          const res = response.data;
          if (res.data) {
            this.dialog = true;
            this.loading = false;
          } else {
            this.dialog2 = true;
            this.loading = false;
          }
        })
        .catch(error => {
          const message = error.response.status.message;
          this.errorMessage = message;
          this.dialog2 = true;
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
.theme--dark.v-icon {
  color: #000000;
}
.theme--dark.v-icon.v-icon.v-icon--disabled {
  color: rgb(2 2 2 / 31%) !important;
}
</style>
